import { Check } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const PLANS = [
    {
        id: "singola",
        testid: "pricing-card-singola",
        name: "Lezione Singola",
        price: "€28",
        note: "Per conoscere lo studio",
        features: ["Reformer, Flow o Gentle", "55 minuti", "Piccoli gruppi max 4"],
    },
    {
        id: "pack5",
        testid: "pricing-card-pack5",
        name: "Pack 5 · Sprint",
        price: "€130",
        per: "€26 a lezione",
        note: "Validità 1 mese",
        features: ["5 lezioni a scelta", "Scadenza 1 mese", "Ideale se vieni spesso"],
    },
    {
        id: "pack5-flex",
        testid: "pricing-card-pack5-flex",
        name: "Pack 5 · Flessibile",
        price: "€150",
        per: "€30 a lezione",
        note: "Validità 3 mesi",
        features: ["5 lezioni a scelta", "Scadenza 3 mesi", "Più tempo per usarle"],
    },
    {
        id: "pack10",
        testid: "pricing-card-pack10",
        name: "Pack 10 · Sprint",
        price: "€200",
        per: "€20 a lezione",
        note: "Validità 1 mese",
        features: ["10 lezioni a scelta", "Scadenza 1 mese", "Il prezzo migliore in assoluto"],
        highlight: true,
        badge: "Il più conveniente",
    },
    {
        id: "pack10-flex",
        testid: "pricing-card-pack10-flex",
        name: "Pack 10 · Flessibile",
        price: "€250",
        per: "€25 a lezione",
        note: "Validità 3 mesi",
        features: ["10 lezioni a scelta", "Scadenza 3 mesi", "Massima libertà"],
    },
    {
        id: "private",
        testid: "pricing-card-private",
        name: "Privata 1:1",
        price: "€65",
        note: "Su di te, soltanto tu",
        features: ["Reformer dedicato", "55 minuti", "Programma personalizzato"],
    },
];

export default function Pricing() {
    return (
        <section id="prezzi" data-testid="pricing-section" className="border-b border-hairline bg-linen px-5 py-24 sm:px-8 md:py-32">
            <div className="mx-auto max-w-6xl">
                <Reveal>
                    <Eyebrow>I percorsi</Eyebrow>
                    <div className="mt-6 flex flex-wrap items-end justify-between gap-6 border-b border-hairline pb-10">
                        <h2 className="max-w-md text-3xl font-light leading-tight tracking-[-0.02em] text-ink sm:text-5xl">
                            Scegli il tuo ritmo
                        </h2>
                        <p className="max-w-xs text-sm font-light leading-relaxed text-body">
                            Sprint se vieni spesso, Flessibile se vuoi più tempo.
                            Pagamento in studio o caparra online.
                        </p>
                    </div>
                </Reveal>

                <div className="mt-12 grid gap-px border border-hairline bg-hairline sm:grid-cols-2 lg:grid-cols-3">
                    {PLANS.map((plan, i) => (
                        <Reveal key={plan.id} delay={i * 0.06} className="h-full">
                            <div
                                data-testid={plan.testid}
                                className={`relative flex h-full flex-col p-8 transition-colors duration-300 ${
                                    plan.highlight
                                        ? "bg-ink text-white"
                                        : "bg-white text-ink hover:bg-linen"
                                }`}
                            >
                                {plan.badge && (
                                    <span className="absolute right-6 top-6 bg-ochre px-2.5 py-1 text-[9px] font-semibold uppercase tracking-[0.2em] text-white">
                                        {plan.badge}
                                    </span>
                                )}
                                <h3 className="pr-20 text-[11px] font-semibold uppercase tracking-[0.24em]">
                                    {plan.name}
                                </h3>
                                <p className={`mt-2 text-xs font-light ${plan.highlight ? "text-white/60" : "text-mute"}`}>
                                    {plan.note}
                                </p>
                                <p className="mt-7 text-5xl font-light tracking-[-0.03em]">
                                    {plan.price}
                                </p>
                                {plan.per && (
                                    <p className="mt-1 text-xs font-medium text-ochre">
                                        {plan.per}
                                    </p>
                                )}
                                <ul className={`mt-8 flex-1 space-y-3 border-t pt-6 ${plan.highlight ? "border-white/15" : "border-hairline"}`}>
                                    {plan.features.map((f) => (
                                        <li key={f} className="flex items-start gap-2.5 text-sm font-light">
                                            <Check className={`mt-0.5 h-4 w-4 shrink-0 ${plan.highlight ? "text-ochre" : "text-ink"}`} strokeWidth={1.5} />
                                            <span className={plan.highlight ? "text-white/80" : "text-body"}>{f}</span>
                                        </li>
                                    ))}
                                </ul>
                                <a
                                    href="#classi"
                                    data-testid={`${plan.testid}-cta`}
                                    className={`mt-8 py-3.5 text-center text-[11px] font-semibold uppercase tracking-[0.2em] transition-all duration-200 active:scale-[0.98] ${
                                        plan.highlight
                                            ? "bg-white text-ink hover:bg-linen"
                                            : "bg-ink text-white hover:bg-charcoal"
                                    }`}
                                >
                                    Prenota ora
                                </a>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
